// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPromoCodeApplyPackageResponse

export type WidgetPromoCodeApplyPackageApiResponse = {
	success: boolean;
	code: string | null;
	discountAmount: number | null;
	amount: number | null;
	error: string | null;
};

export type WidgetPromoCodeApplyPackage = {
	success: boolean;
	code: string | null;
	discountAmount: number | null;
	amount: number | null;
	error: string | null;
};

export function hydrateWidgetPromoCodeApplyPackage(data: WidgetPromoCodeApplyPackageApiResponse): WidgetPromoCodeApplyPackage {
	return { ...data };
}